import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../../shared/components/table/table.component';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { RecebimentoService } from '../../shared/services/recebimento.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from '../../shared/services/toast.service';
import { ModalService } from '../../shared/services/modal.service';
import { ToastState as ts } from '../../shared/enums/toast-state.enum';
import { Recebimento } from '../../shared/models/recebimento';
import { TableHeader } from '../../shared/models/table-header';
import { ButtonVariant } from '../../shared/enums/button-variant.enum';
import { LocalService } from '../../shared/services/local.service';
import { forkJoin } from 'rxjs';
import { Local } from '../../shared/models/local';
import { DropDownOption } from '../../shared/models/drop-down-option';
import { RecebimentoFilter } from './models/recebimento-filter';
import { InputComponent } from '../../shared/components/input/input.component';
import { TegelModule } from '@scania/tegel-angular-17';
import { Fase } from '../../shared/models/fase';
import { FaseService } from '../../shared/services/fase.service';
import { DialogRecebimentoComponent } from './dialog-recebimento/dialog-recebimento.component';
import { DialogRecebimentoDetailsComponent } from './dialog-recebimento-details/dialog-recebimento-details.component';
import { FormatDropDownHelper } from '../../shared/helpers/format-dropdown.helper';
import { LocalContextService } from '../../shared/services/local-context.service';

@Component({
  selector: 'app-recebimento',
  imports: [
    InputComponent,
    ButtonComponent,
    TableComponent,
    FormsModule,
    TegelModule,
  ],
  templateUrl: './recebimento.component.html',
  styleUrl: './recebimento.component.scss',
})
export class RecebimentoComponent implements OnInit {
  recebimentoList: Recebimento[] = [];
  localList: Local[] = [];
  faseList: Fase[] = [];
  ddlLocal: DropDownOption[] = [];
  ddlFase: DropDownOption[] = [];

  headers: TableHeader[] = [
    { value: 'senha', label: 'Senha' },
    { value: 'dataEntrada', label: 'Entrada', pipe: 'datetime' },
    { value: 'dataSaida', label: 'Saída', pipe: 'datetime' },
    { value: 'direcionamento', label: 'Direcionamento' },
    { value: 'registro', label: 'Registro' },
    { value: 'fornecedor', label: 'Fornecedor' },
    { value: 'notaFiscal', label: 'Nota fiscal' },
    { value: 'controlCenter', label: 'Control Center' },
    { value: 'subidaDireta', label: 'Subida direta' },
    { value: 'critico', label: 'Crítico' },
    { value: 'milkrun', label: 'Milk-run' },
  ];

  dataEntrada = '';
  dataSaida = '';
  fornecedor = '';
  notaFiscal = '';
  direcionamento = '';
  registro = '';
  senha = '';
  currentLocalId: number | null = null;

  constructor(
    private toast: ToastService,
    private service: RecebimentoService,
    private localService: LocalService,
    private faseService: FaseService,
    private localContextService: LocalContextService,
    private modal: ModalService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.localContextService.currentLocalId$.subscribe({
      next: (localId) => {
        this.currentLocalId = localId ? +localId : null;
        this.load();
      },
    });
  }

  load() {
    forkJoin({
      recebimentos: this.service.getFiltered(this.buildFilter()),
      locais: this.localService.getAll(),
      fases: this.faseService.getAll(),
    }).subscribe({
      next: ({ recebimentos, locais, fases }) => {
        if (recebimentos && recebimentos.content) {
          this.recebimentoList = [...recebimentos.content];
        }

        if (locais && locais.content) {
          this.localList = [...locais.content];
          this.ddlLocal = FormatDropDownHelper.mapToOptions(
            locais.content,
            'nome',
            'id',
          );
        }

        if (fases && fases.content) {
          this.faseList = [...fases.content];
          this.ddlFase = FormatDropDownHelper.mapToOptions(
            fases.content,
            'nome',
            'id',
          );
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Falha ao carregar recebimentos.',
        );
      },
    });
  }

  create() {
    const data = {
      localList: this.ddlLocal,
    };

    const dialogRef = this.dialog.open(DialogRecebimentoComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Recebimento salvo!');
        this.search();
        // this.recebimentoList = [...this.recebimentoList, result];
      }
    });
  }

  edit(item: Recebimento) {
    const data = {
      recebimento: item,
      localList: this.ddlLocal,
      faseList: this.ddlFase,
    };

    const dialogRef = this.dialog.open(DialogRecebimentoDetailsComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Recebimento atualizado!');
        const index = this.recebimentoList.findIndex(
          (obj) => obj.id == result.id,
        );
        if (index != -1) {
          this.recebimentoList[index] = result;
          this.recebimentoList = [...this.recebimentoList];
        }
      }
    });
  }

  confirmDelete(item: Recebimento) {
    const dialog = this.modal.openConfirmationModal(
      'Exclusão de recebimento',
      'Deseja mesmo excluir?',
      'Excluir',
      ButtonVariant.d,
      'Cancelar',
      ButtonVariant.s,
    );
    dialog.subscribe((result) => {
      if (result) {
        this.delete(item.id);
      }
    });
  }

  delete(id: number) {
    this.service.delete(id).subscribe({
      next: () => {
        this.toast.showToast(ts.success, 'Recebimento excluído.');
        this.recebimentoList = this.recebimentoList.filter(
          (item) => item.id !== id,
        );
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
      },
    });
  }

  buildFilter(): RecebimentoFilter {
    return {
      dataEntrada: this.dataEntrada,
      dataSaida: this.dataSaida,
      fornecedor: this.fornecedor,
      notaFiscal: this.notaFiscal,
      direcionamento: this.direcionamento,
      registro: this.registro,
      senha: this.senha,
      local: this.currentLocalId,
    };
  }

  search() {
    this.service.getFiltered(this.buildFilter()).subscribe({
      next: (value) => {
        if (value && value.content) {
          this.recebimentoList = [...value.content];
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Não foi possível carregar os recebimentos.',
        );
      },
    });
  }
}
